import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import Constants from "../../../../common/Constants";
// import ItemService from "../../../../services/commonService";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
// import QRCode from "react-qr-code";
// import Navbar from "react-bootstrap/Navbar";
const moment = require("moment");

const OverviewMachinesModal = (props) => {
  // const dispatch = useDispatch();
  const [machineDetails, setMachineDetails] = useState([]);

  useEffect(() => {
    if (props?.machineData?.length > 0) {
      setMachineDetails(props?.machineData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <Modal {...props} dialogClassName="modal-90w"  aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          All Running Machines
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {machineDetails?.map((val, index) => (
            <Col lg={3} md={3} sm={3}>
              <Card
                // bg={"primary"}
                text={"white"}
                key={index}
                className=" card machine-overview-card"
                cssNamespace="horizontal"
              >
                <Card.Body>
                  <div className="status-row">
                    <span className="chip chip-blue">
                      <i className="bi bi-diagram-2-fill"></i> &nbsp;
                      {`${val.deptCode} : ${val.deptName}`}
                    </span>
                    <span className="chip chip-blue">
                      <i className="bi bi-tools"></i> &nbsp;{val.machineCode}
                    </span>
                    <span className="chip chip-green">
                      {" "}
                      <i className="bi-person-fill"></i> &nbsp;{" "}
                      {val.operatorUserName}
                    </span>
                    <span className="chip chip-blue">
                      <i className="bi bi-reception-3"></i> &nbsp;
                      {val.sizeCode}
                    </span>

                    {val.jobcard ? (
                      <span className="chip chip-blue">
                        <i className="bi bi-suitcase-lg"></i> &nbsp; {val.jobcard}
                      </span>
                    ) : (
                      val.assignedJobCardList?.map((m, index) => (
                        <span className="chip chip-blue">
                          <i className="bi bi-suitcase-lg"></i> &nbsp; {m}
                        </span>
                      ))
                    )}

                    <span className="chip chip-red">
                      <i className="bi bi-alarm"></i> &nbsp;&nbsp;
                      {val?.updatedDate
                        ? moment(val?.updatedDate).format("DD-MM-YYYY HH:mm:ss")
                        : ""}{" "}
                    </span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default OverviewMachinesModal;
